import validator from 'validatorjs';

const messages: any = {
  same: 'A confirmação não coincide.',
  confirmed: 'A confirmação não coincide.',
  after: 'Deve ser depois que :after.',
  after_or_equal: 'Deve ser igual ou depois que :after_or_equal.',
  email: 'Endereço de e-mail inválido',
  date: 'Data inválida',
  in: 'Inválido',
  integer: 'É obrigatório ter um número',
  min: {
    numeric: 'Valor mínimo :min',
    string: 'Mínimo :min caracteres'
  },
  max: {
    numeric: 'Valor máximo :max',
    string: 'Máximo :max caracteres'
  },
  required: 'Este campo é obrigatório',
  required_if: 'Este campo é obrigatório',
  cpf: 'CPF Inválido',
  cnpj: 'CNPJ Inválido',
  card_validity: 'Validade inválida',
  unique_card: 'Os cartões devem ser diferentes',
  name: 'Precisamos do nome e sobrenome',
  installments: 'Selecione uma parcela',
  requiredSelect: 'Este campo é obrigatório'
};

import './cpf';
import './cnpj';
import './cardValidity';
import './name';
import './installments';
import './requiredSelect';
import './uniqueCard';
import './email';

declare type validationResult = { valid: boolean, message?: string };

export function validate(value: any, rule: string): validationResult {
  if (!rule) return { valid: true };

  const result = new validator({ value }, { value: rule }, messages);

  if (result.passes()) {
    return { valid: true };
  }

  const allErrors = result.errors.all();
  return { valid: false, message: allErrors.value[0] };
}


// WEBPACK FOOTER //
// ./src/validators/index.tsx